import React from "react";
import { Button, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import Locale from "../../locales";
import "./styles.css";

const StudentsList = ({
  addNewClicked,
  students,
  deleteHandler,
  studentClicked,
}) => {
  const selectedStudent = useSelector(
    (state) => state.teacherReducer.currentStudent,
  );

  return (
    <>
      <div className="manage-students-list-container">
        <div className="heading">
          <h1>{Locale.t("your_students")}</h1>
          <Button onClick={addNewClicked} variant="outlined">
            {Locale.t("add_student")}
          </Button>
        </div>
        <div className="main-section">
          {students.map((student) => {
            return (
              <div key={student.studentId} className="student-list-item">
                <Button
                  sx={{ width: "70%" }}
                  onClick={() =>
                    studentClicked(student.studentId, student.studentName)
                  }
                  variant={
                    student.studentId === selectedStudent
                      ? "contained"
                      : "outlined"
                  }
                  color="success">
                  {student?.studentName}
                </Button>
                <Tooltip arrow placement="right" title="Delete">
                  <DeleteIcon
                    type="button"
                    className="delete-button"
                    onClick={() => deleteHandler(student.studentId)}
                  />
                </Tooltip>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default StudentsList;
